import React from 'react';
import MinHeightPage from '../../../registration/view/MinHeightPage';
import ArcPage from '../../../registration/view/ArcPage';
import { Button } from '../../../button/Button';
import clsx from 'clsx';

const StepErrors = ({ title, subTitle, icon, children, buttonLabel, onClick, afterButtonElement }) => {
    return (
        <>
            <MinHeightPage>
                <ArcPage>
                    {icon ? (
                        <ArcPage.Top>
                            <div className="registration-info-icon">{icon}</div>
                        </ArcPage.Top>
                    ) : null}
                    <ArcPage.Body>
                        <div className={clsx({ 'mt-50': !icon })}>
                            <h1>{title}</h1>
                            <h2>{subTitle}</h2>
                        </div>
                    </ArcPage.Body>
                </ArcPage>
                {children}
                <div>
                    <div className={clsx({ 'registration-info-end': icon, 'submit-button': !icon })}>
                        <div className="nui-input p-rel  pb-20 mb-20 flex flex-col">
                            <Button
                                className="nui-button-center nui-button-max-300"
                                primary
                                large
                                onClick={onClick}
                                label={buttonLabel}
                            />
                            {afterButtonElement ? afterButtonElement : null}
                        </div>
                    </div>
                </div>
            </MinHeightPage>
        </>
    );
};

export default StepErrors;
